import { List } from 'immutable';
import { Group } from '../core-data-model/Group.model';
import { GroupsDataService } from './Groups.dataservice';

const getMock: () => Partial<GroupsDataService> = () => {
    const groupsMap: { [key: string]: Group } = {};
    const mockGroupService: Partial<GroupsDataService> = {
        groups: groupsMap,
        getGroup: (teamId: string) =>
            ({
                id: teamId,
                name: 'Test Group Name'
            }) as any,
        isGroupOwner: () => true,
        groupsPromise: Promise.resolve([[], List()]),
        getGroupsWithNameMatch: (match) =>
            Object.values(mockGroupService.groups).filter(
                (g) => g.name === match
            ),
        getCompleteGroup: () => Object.values(mockGroupService.groups),
        getCompanyGroups: () => Object.values(mockGroupService.groups),
        isEditableByUser: (_group) => true,
        nameExists: (_matchName) => true,
        nameLengthExceeds: (_matchName) => _matchName.length > 50,
        createGroup: () => Promise.resolve(new Group()),
        addEntitiesToGroup: () => Promise.resolve([] as any),
        updateGroup: (_team) => Promise.resolve(),
        removeEntitiesFromGroup: () => Promise.resolve([] as any),
        getDreamTeamActionsDefinition: () =>
            ({
                teamActionsByTeamType: {
                    adapting: [
                        {
                            id: 1,
                            translationKey: '1',
                            defaultText: '1'
                        },
                        {
                            id: 2,
                            translationKey: '2',
                            defaultText: '2'
                        },
                        {
                            id: 3,
                            translationKey: '3',
                            defaultText: '3'
                        }
                    ]
                }
            }) as any
    };
    return mockGroupService;
};

export const groupsDataServiceMock = {
    getMock,
    provider: (Service: typeof GroupsDataService) => ({
        provide: Service,
        useValue: getMock()
    })
};
